/** @format */
import { Directive, ElementRef, EventEmitter, Injector, Input, Output } from '@angular/core';
import { UpgradeComponent } from '@angular/upgrade/static';
import { ApplyForGraduationValues } from './applyForGraduationModal-ng.component';

/**
 * @deprecated
 */
@Directive({
    // eslint-disable-next-line @angular-eslint/directive-selector
    selector: 'apply-for-graduation-modal',
    standalone: false,
})
export class ApplyForGraduationModalDirective extends UpgradeComponent {
    @Output() close: EventEmitter<any>;
    @Output() dismiss: EventEmitter<void>;
    @Input() resolve: ApplyForGraduationValues;

    constructor(elementRef: ElementRef<any>, injector: Injector) {
        super('applyForGraduationModal', elementRef, injector);
    }
}
